<template>
    <!-- 岗位支援 -->
    <div>
        <div v-show="Gwzy">
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">岗位支援</div>
            <!-- 主体 -->
            <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
                <!-- 查询框 -->
                <div style="margin-left:3%">
                    <div style="height:40px"></div>
                    <div style="display:inline-block">
                        <span>支援时间 </span>
                        <el-date-picker v-model="condition.date" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" format="yyyy-MM-dd HH:mm" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm">
                        </el-date-picker>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>组织架构 </span>
                        <el-cascader v-model="condition.organize_ids" clearable
                            style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>状态 </span>
                        <el-select v-model="condition.support_type" style="margin-left:10px;width:150px"
                            placeholder="请选择" clearable>
                            <el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 按钮 -->
                    <div style="display:inline-block;margin-left:50px">
                        <el-button type="goon" @click="Find">查询</el-button>
                        <el-button type="goon" @click="Del(null)">删除</el-button>
                        <el-button type="addbtn" @click="add">新增</el-button>
                    </div>
                </div>

                <!-- 表格 -->
                <div style="margin:2% 3% 0 3%">
                    <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%;" height="540" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column align="center" label="序号" width="50">
                            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column prop="organize_name" align="center" label="支援项目"></el-table-column>
                        <el-table-column align="center" label="支援人">
                            <template slot-scope="scope">
                                <el-link type="success" :underline="false" @click="dgr(scope.row.support_staff)">
                                    {{scope.row.support_staff_name}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="start_date" align="center" label="支援开始时间"></el-table-column>
                        <el-table-column prop="end_date" align="center" label="支援结束时间"></el-table-column>
						<!-- <el-table-column prop="daily_wage" align="center" label="日工资"></el-table-column> -->
						<el-table-column prop="delay_reason" align="center" label="延期原因"></el-table-column>
						<el-table-column prop="delay_date" align="center" label="延期时间"></el-table-column>
						<el-table-column prop="return_reason" align="center" label="退回时间"></el-table-column>
                        <el-table-column align="center" label="状态" width=100>
                            <template slot-scope="scope">
                                <img src="../../../../assets/stateImg/状态_未接收.png"
                                    v-show="scope.row.support_type === '0'" />
                                <img src="../../../../assets/stateImg/状态_已接收.png"
                                    v-show="scope.row.support_type === '1'" />
									<img src="../../../../assets/stateImg/状态_已退回.png"
									    v-show="scope.row.support_type === '2'" />
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="150">
                            <template slot-scope="scope">
                                <img src="../../../../assets/编辑.png" @click="Edit(scope.row)">
                                <img src="../../../../assets/删除.png" @click="Del(scope.row.id)">
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <el-row style="margin-top: 10px; text-align: center;">
                        <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                            layout=" prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </el-row>
                </div>

            </div>
        </div>
        <add ref="adds" v-show="showadd" :organizeList="organizeList"></add>
        <!-- 支援人 -->
        <el-dialog title="支援人" v-if="dialogVisible" :visible.sync="dialogVisible" width="40%"
            :close-on-click-modal="false" :center="true" :before-close="handleClose">
            <dgr ref="dais" v-show="showdai" :support_staff_List="support_staff_List"></dgr>
        </el-dialog>
    </div>
</template>

<script>
    import add from './Gwzy_add.vue';
    import dgr from './Gwzy_dai.vue';
    import axios from 'axios';
    export default {
        components: {
            dgr: dgr,
            add: add,
        },
        data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //条件
                condition: {
                    organize_ids: [],
                    date: '',
                    start_date: '',
                    end_date: '',
                    support_type: '',
                },

                //详情
                ruleForm: {
                    id: '',
                    project_id: '',
                    project_name: '',
                    support_staff: '',
                    support_staff_name: '',
                    start_date: '',
                    end_date: '',
                    operator_name: '',
                    operator_date: '',
                    organize_ids:'',
                    organize_temporary_ids:'',
                    cost_bearing_party:'0',
                },

                // 权限
                Gwzy: true,
                showdai: false,
                showadd: false,

                //页面相关
                dialogVisible: false,

                //删除ids
                ids: [],

                //状态
                ztList: [{
                    value: '0',
                    label: '待接收'
                }, {
                    value: '1',
                    label: '已接收'
                },{
                    value: '2',
                    label: '已延期'
                }, {
                    value: '3',
                    label: '已退回'
                }],

                //支援人
                support_staff_List: [],
                
                //级联下拉配置
                props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
                    value: "id",
                    label: "organize_name",
                    children: "organizeList",
                    checkStrictly: true,
                    multiple: true,
                },
                
                //组织架构数据
                organizeList: [],
            };
        },
        methods: {
            // 全选
            handleSelectionChange(e) {
                this.ids = [];
                e.forEach((item) => {
                    this.ids.push(item.id);
                });
            },
            // 弹窗
            handleClose() {
                this.dialogVisible = false
            },
            // 新增
            add() {
                this.trash();
                this.ruleForm.operator_date = this.$globals.getNowTime();
                this.ruleForm.operator_name = this.$globals.user.name;
                this.Gwzy = false;
                this.showadd = true;
            },
            // 查看代岗人
            async dgr(e) {

                var support_staff_List = await this.$globals.AxiosPost("staff/selectFind", {
                    idString: e
                });
                this.support_staff_List = support_staff_List.data;

                this.dialogVisible = true;
                this.showdai = true;
            },
            // 返回
            Return() {
                this.showadd = false;
                this.Gwzy = true;
                this.trash();
                this.Find();
            },
            // 操作删除
            async Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }

                var url = "postSupport/del";
                var record = {
                    ids: ids,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            // 操作详情
            Edit(e) {
                this.Gwzy = false;
                this.showadd = true;

                this.ruleForm.id = e.id;
                this.ruleForm.project_id = e.project_id;
                this.ruleForm.project_name = e.organize_name;
                this.ruleForm.support_staff = e.support_staff;
                this.ruleForm.support_staff_name = e.support_staff_name;
                this.ruleForm.start_date = e.start_date;
                this.ruleForm.end_date = e.end_date;
                this.ruleForm.operator_name = e.operator_name;
                this.ruleForm.operator_date = e.operator_date;
            },
            //查询
            async Find() {
                var temporary = [];
                this.condition.organize_ids.forEach(item => {
                    temporary.push(item[item.length - 1]);
                })
                var organize_ids = "";
                temporary.forEach(item => {
                    organize_ids += item + ",";
                })
                
                var url = 'postSupport/find';
                var record = {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    project_id: organize_ids,
                    start_date: this.ruleForm.date != null && this.ruleForm.date != '' ? this.ruleForm.date[0] :
                        "",
                    end_date: this.ruleForm.date != null && this.ruleForm.date != '' ? this.ruleForm.date[1] :
                        "",
                    support_type: this.condition.support_type,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.warning('请求失败！请稍后重试');
                    }
                }
            },
            //分页
            handleCurrentChange(val) {
                this.page_num = val;
                this.Find();
            },
            //清除数据
            trash() {
                this.ruleForm.id = '';
                this.ruleForm.project_id = '';
                this.ruleForm.project_name = '';
                this.ruleForm.support_staff = '';
                this.ruleForm.support_staff_name = '';
                this.ruleForm.start_date = '';
                this.ruleForm.end_date = '';
                this.ruleForm.operator_name = '';
                this.ruleForm.operator_date = '';
                this.ruleForm.cost_bearing_party = '0';
				this.supportStaffList = [];
            },
            //初始化组织架构及下面的人
            async organizeFind() {
                var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                    identification: "1",
                    id: this.condition.project_id
                });
                this.organizeList = this.getTreeData(organizeList.data);

            },
            getTreeData(data) {
                // 循环遍历json数据
                for (var i = 0; i < data.length; i++) {

                    if (data[i].organizeList.length < 1) {
                        // children若为空数组，则将children设为undefined
                        data[i].organizeList = undefined;
                    } else {
                        // children若不为空数组，则继续 递归调用 本方法
                        this.getTreeData(data[i].organizeList);
                    }
                }
                return data;
            }
        },
        created() {
            this.Find();
            this.organizeFind();
        },
    };
</script>

<style>
    .el-button--goon:focus,
    .el-button--goon:hover {
        background: #006e4b;
        border-color: #05573d;
        color: #fff;
    }

    .el-button--addbtn:focus,
    .el-button--addbtn:hover {
        background: #fff;
        border-color: #05573d;
        color: #006e4b;
    }

    .el-button--goon {
        color: #fff;
        background-color: #006e4b;
        border-color: #006e4b;
        font-size: 15px;
        width: 85px;
    }

    .el-button--addbtn {
        color: #006e4b;
        background-color: #fff;
        border-color: #006e4b;
        font-size: 15px;
        width: 85px;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #006e4b;
        border-color: #006e4b;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #006e4b;
    }

    .el-checkbox__inner:hover {
        border-color: #006e4b;
    }
</style>



// WEBPACK FOOTER //
// Gwzy.vue?0eeb80a8